document.addEventListener('DOMContentLoaded', () => {
    const slides = document.querySelectorAll('.mentor-slide');
    if (slides.length > 1) {
        let currentIndex = 0;
        setInterval(() => {
            slides[currentIndex].classList.remove('active');
            setTimeout(() => {
                slides[currentIndex].style.display = 'none';
                currentIndex = (currentIndex + 1) % slides.length;
                slides[currentIndex].style.display = 'flex';
                setTimeout(() => {
                    slides[currentIndex].classList.add('active');
                }, 50);
            }, 800); // Increased from 500 to 800 to allow for exit animations
        }, 6000); // Slightly increased interval to enjoy the animation

        // Ensure initial state is set
        slides.forEach((slide, index) => {
            if (index !== 0) slide.style.display = 'none';
            else slide.style.display = 'flex';
        });
    }
});
